import qs from 'qs';
import { useParams } from 'react-router';
import { useLocation, useHistory } from 'react-router-dom';

const QueryHook = () => {
	const location = useLocation();
	const navigate = useHistory();
	const routeParams = useParams();
	const query = qs.parse(location.search, { ignoreQueryPrefix: true });

	const QueryParams = query;

	const stringify = (obj, params) => qs.stringify(obj, params);

	const AddQueryParams = params => {
		navigate.replace(`?${qs.stringify({ ...params })}`); // replace
	};

	const MergeQueryParams = (params, replace = true) => {
		const newQuery = qs.stringify({ ...query, ...params });
		if (replace) navigate.replace(`?${newQuery}`); // replace = true
		else navigate.push(`?${newQuery}`);
	};

	return { QueryParams, AddQueryParams, MergeQueryParams, stringify, navigate, location, routeParams };
};

export default QueryHook;
